var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certified-email-wrap"},[_c('i',{staticClass:"h5pp",class:_vm.showEmailPage === 1 ? 'h5pp-icon-done' : 'h5pp-icon-faile'}),_c('span',[_vm._v(_vm._s(_vm.showEmailPage === 1 ? '您已完成邮箱认证，可关闭此页面，继续浏览内推官网' : '邮箱认证不通过，可返回上一步重新发送认证邮件'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }